import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';
import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

export const utagTargetedOffersLoad = (
  { loyaltyID, email, length },
  success,
  callback,
) => {
  const interactionType = {
    eventType: TRACKING_ACTION.INTERACTIONS,
    interaction: success
      ? TRACKING_INTERACTION.TARGETED_OFFERS.LOOKUP_SUCCESS
      : TRACKING_INTERACTION.TARGETED_OFFERS.LOOKUP_ERROR,
  };

  const info = success
    ? {
        targetedOfferResult: length,
        ...(email && { email }),
        ...(loyaltyID && { loyaltyNum: loyaltyID }),
      }
    : null;

  const interaction = createUserInteraction(interactionType, info);

  trackEvent(interaction);

  if (callback) {
    callback();
  }
};
